export const OBJECT_WORDING = {
    Portfolios: {
        upper: "Workbench",
        upperPlural: "Workbenches",
        lower: "workbench",
        lowerPlural: "workbenches",
    },
    Dashboards: {
        upper: "Dashboard",
        upperPlural: "Dashboards",
        lower: "dashboard",
        lowerPlural: "dashboards",
    },
    Services: {
        upper: "Services file",
        upperPlural: "Services files",
        lower: "services file",
        lowerPlural: "services files",
    },
    Operations: {
        upper: "Operation",
        upperPlural: "Operations",
        lower: "operation",
        lowerPlural: "operations",
    },
    Reports: {
        upper: "Report",
        upperPlural: "Reports",
        lower: "report",
        lowerPlural: "reports",
    },
    GeneralFiles: {
        upper: "File",
        upperPlural: "Files",
        lower: "file",
        lowerPlural: "files",
    },
    WatchLists: {
        upper: "Watch list",
        upperPlural: "Watch lists",
        lower: "watch list",
        lowerPlural: "watch lists",
    },
    Folder: {
        upper: "Folder",
        upperPlural: "Folders",
        lower: "folder",
        lowerPlural: "folders",
    },
    Password: {
        upper: "Your password",
        upperPlural: "Your passwords",
        lower: "your password",
        lowerPlural: "your passwords",
    },
    Order: {
        upper: "Order",
        upperPlural: "Orders",
        lower: "order",
        lowerPlural: "orders",
    },
    Compliance: {
        upper: "Compliance",
        upperPlural: "Compliance",
        lower: "compliance",
        lowerPlural: "compliance",
    },
};
const toastActionContent = (w, past, present) => ({
    success: `${w.upper} ${past} successfully`,
    failure: `Failed to ${present} ${w.lower}`,
});
function createExplorerActionStatusTexts(section) {
    const wording = OBJECT_WORDING[section];
    return {
        save: toastActionContent(wording, "saved", "save"),
        create: toastActionContent(wording, "created", "create"),
        rename: toastActionContent(wording, "renamed", "rename"),
        copy: toastActionContent(wording, "copied", "copy"),
        move: toastActionContent(wording, "moved", "move"),
        delete: toastActionContent(wording, "deleted", "delete"),
        share: {
            success: `Copied ${wording.lower} share link`,
            failure: `Failed to copy ${wording.lower} share link`,
        },
    };
}
export const TOAST_CONTENT = {
    Reports: createExplorerActionStatusTexts("Reports"),
    Services: createExplorerActionStatusTexts("Services"),
    Operations: createExplorerActionStatusTexts("Operations"),
    Portfolios: {
        ...createExplorerActionStatusTexts("Portfolios"),
        tourError: "Tour canceled because workbench failed to load",
    },
    Dashboards: createExplorerActionStatusTexts("Dashboards"),
    GeneralFiles: createExplorerActionStatusTexts("GeneralFiles"),
    WatchLists: createExplorerActionStatusTexts("WatchLists"),
    folder: createExplorerActionStatusTexts("Folder"),
    password: {
        change: toastActionContent(OBJECT_WORDING.Password, "was changed", "change"),
    },
    oems: {
        newOrder: toastActionContent(OBJECT_WORDING.Order, "staged", "stage"),
        split: toastActionContent(OBJECT_WORDING.Order, "split", "split"),
        fill: toastActionContent(OBJECT_WORDING.Order, "fill added", "add fill"),
        cancel: toastActionContent(OBJECT_WORDING.Order, "cancelled", "cancel"),
        transmit: toastActionContent(OBJECT_WORDING.Order, "transmitted", "transmit"),
        tourError: "Tour canceled because OMS failed to load",
        compliance: {
            ...toastActionContent(OBJECT_WORDING.Compliance, "ran", "run"),
            warn: "Compliance completed with warnings",
            default: "Compliance state unchanged",
        },
    },
};
export const pwbColumnDescriptions = {
    benchmarkName: "Name of the benchmark(s) that are associated with a particular fund.",
    duration: "Duration of the instrument held or weighted average when aggregated.",
    benchmarkDuration: "Duration of the instrument held by the benchmark or weighted average when aggregated.",
    currentExposure: "Exposure defined by the numerator aggregation set in the settings.",
    finalExposure: "Editable. Pro-forma exposure. Current Ex plus Inc Ex.",
    incrementalExposure: "Editable. Incremental exposure. Final Ex minus Current Ex.",
    benchmarkExposurePercentNAV: "Benchmark exposure as a percent.",
    currentExposurePercentNAV: "Current Ex divided by the denominator set in the settings.",
    finalExposurePercentNAV: "Final Ex divided by the denominator set in the settings.",
    incrementalExposurePercentNAV: "Inc Ex divided by the denominator set in the settings.",
    country: "Country of the security.",
    riskCountry: "Country of the security to which it is predominantly exposed.",
    assetClass: "Group of similar instrument types (i.e, equity and fixed income).",
    instrumentCcy: "Currency in which a given instrument is denominated.",
    instrumentSubtype: "Subgroup of instrument types (e.g., corporate bonds and government bonds).",
    instrument: "Primary method of grouping instruments together at Enfusion (e.g., equity and bond).",
    currentMV: "Local market value displayed in the fund's base currency. This not impacted by the settings.",
    finalMV: "Editable. Pro-forma market value. Current MV plus Inc MV.",
    IncMV: "Editable. Incremental market value. Final MV minus Current MV.",
    currentNAV: "Current net asset value calculated using the denominator set in the settings.",
    finalNAV: "Editable. Pro-forma NAV. Current NAV plus Inc NAV.",
    incrementalNAV: "Editable. Amount of any modeled subscriptions or redemptions. Final NAV minus Current NAV.",
    price: "Editable. Price used to calculate exposure.",
    issuer: "Entity that issued a given security.",
    account: "Custodian account.",
    fund: "The long name of the fund.",
    FundSN: "The short name or code of the fund.",
    currentQuantity: "Current quantity of the holding.",
    finalQuantity: "Editable. Pro-forma quantity. Current Qty plus Inc Qty.",
    incrementalQuantity: "Editable. Proposed order quantity. Final Qty minus Current Qty.",
    sector: "The highest level group in the GICS global industry classification standard (e.g., Financials).",
    industry: "The third-highest grouping level in the GICS global industry classification standard (e.g., Capital Markets & Financial Services).",
    industryGroup: "The second-highest grouping level in the GICS global industry classification standard (e.g., Banks & Insurance).",
    subIndustry: "The most granular group in the GICS global industry classification standard (e.g., Life Insurance vs. Property & Casualty Insurance).",
    bbYellow: "The conventional Bloomberg symbol, which is a combination of the exchange ticker plus the countries exchange code plus the asset class. For example, Apple Inc is AAPL US because it is the US composite of all exchanges.",
    cusip: "The CUSIP number is a unique identification number assigned to all stocks and registered bonds in the United States and Canada; it is used to create a concrete distinction between securities that are traded on public markets.",
    isin: "International Securities Identification Numbering system is the global ISO standard for unique identification of financial and referential instruments, including equity, debt, derivatives, and indices.",
    sedol: "The Stock Exchange Daily Official List, which is a list of security identifiers; this field is empty unless licensed from LSEG.",
};
